var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{staticClass:"alignTableOnBackground ml-5 mr-5 elevation-1",attrs:{"headers":_vm.headers,"items":_vm.listRtpEngine,"single-expand":"","search":_vm.search,"loading":_vm.loading,"item-key":"callid"},scopedSlots:_vm._u([{key:"item.Instance",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.clearName(item.Instance))+" ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }